// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import Responsive from "react-responsive-decorator";
import JSZip from "jszip";
import styles from "./createTicket.scss";
import {
  ticketTypesDetailsStrings,
  pageObj,
  sourceOptions,
  maxMobileNumberLength,
  minMobileNumberLength,
  assigneeTypes,
  formKeys,
  analyticsEventList,
  hideTicketTypeOptionsList,
  primeGroupTypesList,
  maxCNOTELength
} from "./createTicketHelper";
import { getGroupTypesByBu } from "../categorySettings/categorySettingsRedux/categorySettingsActionCreator";
import { getGroupSuggestion } from "../../../commons/ticketingSuggestionModal/ticketingSuggestionModalRedux/ticketingSuggestionModalActionCreator";
import {
  getSeverityOptions,
  severityOptions
} from "../../../containers/ticketing/ticketDashboard/ticketDashboardHelper";
import { setPageName } from "../../../../services/pageService/pageActionCreator";
import Loader from "../../../commons/loader/loader";
import Attachments from "../../../commons/attachments/attachments";
import Modal from "../../../commons/modal/modal";
import BasicSelect from "../../../commons/formElements/basicSelect/basicSelect";
import RichTextInput from "../../../commons/formElements/richTextInput/richTextInput";
import InputField from "../../../commons/formElements/inputField/inputField";
import TicketingCcModal from "../../../commons/ticketingCcModal/ticketingCcModal";

import {
  navigateToRouteHelper,
  enableOnlyNumberInput,
  isValidEmail,
  isNullOrEmptyString,
  sendGaEvent
} from "../../../../services/helpers";

import {
  getAllTicketTypes,
  getTicketTypeDTO,
  createTicketSubmit,
  getEntityInfoDetails,
  getUserInfo,
  getAssigneeOptions,
  getClientCodeOptions,
  getPrimeClientCodeOptions,
  clearStateAction,
  getFilteredPrimeClientCodeOptionsAction,
  getCcDetails,
  getBuTypes,
  getEntityTypes,
  getLocationData
} from "./createTicketRedux/createTicketActionCreator";
import {
  getTicketDetails,
  sendCommentsDetails
} from "../viewTicket/viewTicketRedux/viewTicketActionCreator";
import { flushAttachmentState } from "../../../commons/attachments/attachmentsRedux/attachmentActionCreator";

type Props = {
  createTicketState: Object,
  setPageName: Function,
  getAllTicketTypes: Function,
  getTicketTypeDTO: Function,
  createTicketSubmit: Function,
  userProfile: Object,
  getEntityInfoDetails: Function,
  getUserInfo: Function,
  getAssigneeOptions: Function,
  history: Object,
  getClientCodeOptions: Function,
  getPrimeClientCodeOptions: Function,
  getFilteredPrimeClientCodeOptionsAction: Function,
  getTicketDetails: Function,
  viewTicketState: Object,
  params: Object,
  clearStateAction: Function,
  getCcDetails: Function,
  getBuTypes: Function,
  attachmentState: Object,
  sendCommentsDetails: Function,
  ticketingSuggestionModalState: Object,
  getGroupSuggestion: Function,
  getEntityTypes: Function,
  getGroupTypesByBu: Function,
  categorySettingsState: Object,
  flushAttachmentState: Function,
  getLocationData: Function
};

type State = {
  typeId: Integer,
  source: String,
  showAssigneeOptions: Boolean,
  assigneeId: Integer,
  name: String,
  email: String,
  mobileNo: String,
  showClientCodeOptions: Boolean,
  ticketCreated: Boolean,
  showTicketTypeOptions: Boolean,
  ticketCreatedId: Integer,
  showTicketCreatedModal: Boolean,
  assigneeType: String,
  clientCode: String,
  clientName: String,
  incompleteTicket: Boolean,
  ticketTypeDTO: Object,
  subject: String,
  parentId: Integer,
  fillingFromAPIResponse: Boolean,
  groupTypeId: Integer
};

class CreateTicket extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      typeId: null,
      source: this.getDefaultSource().val,
      entityInput: null,
      title: null,
      showAssigneeOptions: false,
      subject: null,
      clientCode: null,
      clientName: null,
      assigneeId: null,
      mobileNo: null,
      name: null,
      email: null,
      showClientCodeOptions: false,
      ticketCreated: false,
      showTicketTypeOptions: false,
      ticketCreatedId: false,
      showTicketCreatedModal: false,
      assigneeType: assigneeTypes.NONE,
      incompleteTicket: false,
      parentId: null,
      fillingFromAPIResponse: this.props.params.id,
      invalidCnOrPRQ: false,
      assigneeName: null,
      type: null,
      ccList: [],
      showCCModal: false,
      buId:
        this.props.userProfile &&
        this.props.userProfile.business_unit &&
        this.props.userProfile.business_unit.id,
      notificationEnabled: true,
      severity: null,
      showAttachmentModal: false,
      zipFileToBeSent: null,
      groupSuggestion: null,
      groupTypeId: null
    };
    this.assigneeSearchTimeout = null;
    this.props.clearStateAction();
    this.props.flushAttachmentState();
  }

  componentDidMount() {
    this.props.setPageName(pageObj);
    this.props.getBuTypes();
    this.props.getAllTicketTypes(this.state.buId);
    this.props.getGroupTypesByBu(this.state.buId);
    this.props.getPrimeClientCodeOptions();
    this.props.getEntityTypes();
    this.props.getLocationData();
    if (this.props.params.id) {
      this.props.getTicketDetails(this.props.params.id);
    }
    this.sendGaEventObject("render");
  }

  componentWillReceiveProps(nextProps) {
    const {
      userInfo,
      ticket,
      ticketTypeDTO,
      orgClientInfoDetails,
      ccEmailDetails
    } = nextProps.createTicketState;
    const { groupSuggestion } = nextProps.ticketingSuggestionModalState;
    if (userInfo.isLoaded && !this.props.createTicketState.userInfo.isLoaded) {
      this.updateUserInfo(userInfo);
    } else if (ticket.data !== this.props.createTicketState.ticket.data) {
      this.updateTicketData(ticket);
    } else if (
      orgClientInfoDetails.isLoaded &&
      !this.props.createTicketState.orgClientInfoDetails.isLoaded
    ) {
      this.handleEntityInputChange(orgClientInfoDetails, ticketTypeDTO);
    } else if (
      this.props.params.id &&
      nextProps.viewTicketState.ticketDetails.data !==
        this.props.viewTicketState.ticketDetails.data
    ) {
      this.handleIncompleteAndChildTickets(
        nextProps.viewTicketState.ticketDetails.data
      );
    } else if (
      ticketTypeDTO.data !== this.props.createTicketState.ticketTypeDTO.data
    ) {
      this.makeAutoSuggestionCall("", ticketTypeDTO, this.state.clientCode);
    } else if (
      !this.props.ticketingSuggestionModalState.groupSuggestion.isLoaded &&
      groupSuggestion.isLoaded &&
      groupSuggestion.data
    ) {
      this.setAssigneeFromAPIResponse(groupSuggestion.data);
    } else if (
      ccEmailDetails.isLoaded &&
      !this.props.createTicketState.ccEmailDetails.isLoaded
    ) {
      this.updateCcList(ccEmailDetails);
    }
  }

  onFormChange(key, val, event) {
    this.setState(
      {
        [key]: (event && event.val) || val,
        showTicketTypeOptions: false,
        showAssigneeOptions: false,
        showClientCodeOptions: false,
        typeId: key === formKeys.TYPE && event ? event.id : this.state.typeId,
        buId: key === formKeys.BU && event ? event.id : this.state.buId,

        clientName:
          key === formKeys.CLIENT && event
            ? event.clientName
            : this.state.clientName,
        assigneeId:
          key === formKeys.ASSIGNEE && event ? event.id : this.state.assigneeId,
        assigneeType:
          key === formKeys.ASSIGNEE && event
            ? this.getAssigneeType(event)
            : this.state.assigneeType,
        groupTypeId: this.getGroupTypeIdOnFormChange(key, event)
      },
      () => {
        if (key === formKeys.TYPE) {
          this.props.getTicketTypeDTO(this.state.typeId);
        } else if (key === formKeys.BU) {
          this.props.getAllTicketTypes(this.state.buId);
          this.props.getGroupTypesByBu(this.state.buId);
        } else if (key === formKeys.CLIENT) {
          this.makeAutoSuggestionCall(
            "",
            this.props.createTicketState.ticketTypeDTO,
            this.state.clientCode
          );
        } else if (
          key === formKeys.ENTITY &&
          this.props.createTicketState.ticketTypeDTO.data &&
          this.props.createTicketState.ticketTypeDTO.data.entityType &&
          this.props.createTicketState.ticketTypeDTO.data.entityType.toLowerCase() ===
            "location"
        ) {
          // Trigger auto-suggestion when entity is selected
          this.makeAutoSuggestionCall(
            "",
            this.props.createTicketState.ticketTypeDTO,
            this.state.clientCode
          );
        }
      }
    );
    // eslint-disable-next-line
    console.log("type", this.state.type);
    // eslint-disable-next-line
    console.log("assignee name", this.state.assigneeName);
  }

  onChangeAssigneeInput(val: String) {
    this.setState(
      {
        showAssigneeOptions: true
      },
      () => {
        this.makeAutoSuggestionCall(
          val || "",
          this.props.createTicketState.ticketTypeDTO,
          this.state.clientCode
        );
      }
    );
  }

  onChangeClientCodeInput(val: String) {
    this.setState(
      {
        showClientCodeOptions: true
      },
      () => {
        if (!isNullOrEmptyString(val)) {
          this.props.getClientCodeOptions(val);
        }
      }
    );
  }

  onChangePrimeClientCodeInput(val: String) {
    this.setState(
      {
        showClientCodeOptions: true
      },
      () => {
        if (!isNullOrEmptyString(val)) {
          this.props.getFilteredPrimeClientCodeOptionsAction(val);
        }
      }
    );
  }

  onTicketCreatedModalClick() {
    this.setState({
      showTicketCreatedModal: false
    });
    const viewTicketRouteObj = {
      route: `/viewticket/${this.state.ticketCreatedId}`,
      zoomuinewroute: true
    };
    navigateToRouteHelper(viewTicketRouteObj);
  }

  getAssigneeSelectOptions(assigneeOptions) {
    const tableData = [];
    if (assigneeOptions.data) {
      if (assigneeOptions.data.groupList) {
        assigneeOptions.data.groupList.forEach(user => {
          tableData.push({
            key: user.name,
            val: user.name,
            id: user.id,
            isGroup: true
          });
        });
      }
      if (assigneeOptions.data.userList) {
        assigneeOptions.data.userList.forEach(user => {
          tableData.push({
            key: user.name ? `${user.name} ${user.email}` : user.email,
            val: user.name ? user.name : user.email,
            id: user.id,
            isGroup: false
          });
        });
      }
    }
    return tableData;
  }

  getAssigneeSelectedOpt() {
    if (this.fillForIncompleteTickets()) {
      return this.props.viewTicketState.ticketDetails.data.assigneeName;
    }
    if (this.state.groupSuggestion) {
      return this.state.groupSuggestion.name;
    }
    return null;
  }

  getAssigneeType(event) {
    return event.isGroup ? assigneeTypes.GROUP : assigneeTypes.USER;
  }

  getBuSelectOptions(buTypes) {
    if (buTypes.isLoaded && buTypes.data) {
      return buTypes.data.map(option => ({
        key: `${option.unitName}`,
        val: `${option.unitName}`,
        id: option.id
      }));
    }
    return [];
  }

  getClientCodeSelectOptions(clientCodeOptions) {
    if (clientCodeOptions.isLoaded && clientCodeOptions.data) {
      return clientCodeOptions.data.map(option => ({
        key: `${option.code} ${option.name}`,
        val: `${option.code}`,
        clientName: option.name
      }));
    }
    return [];
  }

  getPrimeClientCodeSelectOptions(primeClientCodeOptions) {
    if (
      primeClientCodeOptions.isLoaded &&
      primeClientCodeOptions.filteredData
    ) {
      return primeClientCodeOptions.filteredData
        .filter(client => client.cmsClientCode && client.cmsClientCode !== "")
        .map(option => ({
          key: `${option.code} ${option.clientName}`,
          val: `${option.cmsClientCode}`,
          clientName: option.clientName
        }));
    }
    return [];
  }

  getClientCodeSelectedOpt(orgClientInfoDetails) {
    // orgClientInfoDetails.data can be null if invalid cn/prq
    if (orgClientInfoDetails.isLoaded && !this.state.invalidCnOrPRQ) {
      return orgClientInfoDetails.data && orgClientInfoDetails.data.clientCode;
    }
    if (this.fillForIncompleteTickets()) {
      return this.props.viewTicketState.ticketDetails.data.clientName;
    }

    return null;
  }

  getDefaultSeverity() {
    return "ONE"; // default severity
  }

  getDefaultSource() {
    return sourceOptions[0];
  }

  getGroupTypeIdOnFormChange(key, event) {
    if (key === formKeys.BU) {
      return null;
    }
    if (key === formKeys.GROUP_TYPE && event) {
      return event.id;
    }
    return this.state.groupTypeId;
  }

  getGroupTypeSelectOptions(groupTypes) {
    let groupTypesToReturn = [];
    if (groupTypes.isLoaded && groupTypes.data) {
      groupTypesToReturn = groupTypes.data.map(type => ({
        key: type.displayName,
        val: type.displayName,
        id: type.id
      }));
    }
    return groupTypesToReturn;
  }

  getLocationSelectOptions(locationData) {
    const locationOptions = [];
    if (locationData && locationData.isLoaded && locationData.data) {
      locationData.data.forEach(location => {
        if (
          location.status === "ACTIVE" &&
          (location.locationType === "PROCESSING_CENTER" ||
            location.locationType === "HEADQUARTER" ||
            location.locationType === "BRANCH")
        ) {
          locationOptions.push({
            key: `${location.code}`,
            val: location.code,
            id: location.id
          });
        }
      });
    }
    return locationOptions;
  }

  getOrganisationClientDetails(type, val) {
    if (val) {
      this.props.getEntityInfoDetails(type, val);
    }
  }

  getSeveritySelectedOpt() {
    if (this.fillForIncompleteTickets()) {
      return this.props.viewTicketState.ticketDetails.data.severity;
    }
    return null;
  }

  getUserInfo(param: String, isEmail: Boolean) {
    if (param) {
      if (isEmail) {
        if (!isValidEmail(param)) {
          toastr.error("Please enter valid email");
          return;
        }
      } else if (param.length < minMobileNumberLength) {
        toastr.error("Please enter atleast 9 digits as phone number");
      }
      this.sendGaEventObject("requestor_search");
      this.props.getUserInfo(param, isEmail);
    }
  }

  getTypeSelectOptions(ticketTypes) {
    const ticketTypesObjectToReturn = [];
    if (ticketTypes.isLoaded && ticketTypes.data) {
      ticketTypes.data.forEach(type => {
        if (
          !(hideTicketTypeOptionsList.indexOf(type.key) >= 0) &&
          (!this.state.groupTypeId ||
            type.option === this.state.groupTypeId.toString())
        ) {
          ticketTypesObjectToReturn.push({
            key: type.key,
            val: type.key,
            id: type.val
          });
        }
      });
    }
    return ticketTypesObjectToReturn;
  }

  setAssigneeFromAPIResponse(assignee) {
    if (assignee.groupList && assignee.groupList.length) {
      this.setState({
        assigneeId: assignee.groupList[0].id,
        assigneeType: assigneeTypes.GROUP,
        groupSuggestion: assignee.groupList[0]
      });
    } else if (assignee.userList && assignee.userList.length) {
      this.setState({
        assigneeId: assignee.userList[0].id,
        assigneeType: assigneeTypes.USER,
        groupSuggestion: assignee.userList[0]
      });
    }
  }

  isPrimeClientCodeRequired(ticketTypeDTO) {
    return (
      ticketTypeDTO.isLoaded &&
      ticketTypeDTO.data &&
      primeGroupTypesList.indexOf(ticketTypeDTO.data.groupTypeDTO.id) >= 0
    );
  }

  sendGaEventObject(label) {
    sendGaEvent(
      analyticsEventList[label],
      "zoom-panel-ticketing-create-ticket",
      this.props.userProfile
    );
  }

  fillForIncompleteTickets() {
    return (
      this.state.fillingFromAPIResponse &&
      this.state.incompleteTicket &&
      this.props.viewTicketState.ticketDetails.data
    );
  }

  handleAssigneeBlur() {
    this.setState({
      showAssigneeOptions: false
    });
  }

  handleChildTickets(data) {
    this.setState(
      {
        typeId: data.ticketTypeDTO.id,
        title: data.title,
        mobileNo: data.requestor.mobileNo,
        email: data.requestor.email,
        name: data.requestor.name,
        parentId: this.props.params.id,
        buId: data.ticketTypeDTO.businessUnitDTO.id
      },
      () => {
        this.props.getAllTicketTypes(this.state.buId);
        this.props.getTicketTypeDTO(this.state.typeId);
      }
    );
  }

  handleClientCodeBlur() {
    this.setState({
      showClientCodeOptions: false
    });
  }

  handleEntityInputChange(orgClientInfoDetails, ticketTypeDTO) {
    const isInvalid = !orgClientInfoDetails.data;
    this.setState(
      {
        invalidCnOrPRQ: isInvalid,
        clientCode:
          !isInvalid && orgClientInfoDetails.data.clientCode
            ? orgClientInfoDetails.data.clientCode
            : this.state.clientCode,
        clientName:
          !isInvalid && orgClientInfoDetails.data.clientCode
            ? orgClientInfoDetails.data.clientName
            : this.state.clientName
      },
      () => {
        if (
          ticketTypeDTO.data.entityType === "CN" ||
          ticketTypeDTO.data.entityType === "PRQ"
        ) {
          if (this.state.invalidCnOrPRQ) {
            toastr.error(`Enter valid ${ticketTypeDTO.data.entityType}`);
          } else if (
            orgClientInfoDetails.data.isActive &&
            orgClientInfoDetails.data.isActive === 2
          ) {
            toastr.info(`${ticketTypeDTO.data.entityType} is stale`);
          } else {
            switch (orgClientInfoDetails.data.status) {
              case "COMPLETE":
                toastr.info(`${ticketTypeDTO.data.entityType} is completed`);
                break;
              case "DELETED":
              case "DELETED_BY_BP":
                toastr.info(`${ticketTypeDTO.data.entityType} is deleted`);
                break;
              case "DELIVERED":
              case "DELIVERED_POD_PENDING":
                toastr.info(`${ticketTypeDTO.data.entityType} is delivered`);
                break;
              default:
                break;
            }
          }
        }
        this.makeAutoSuggestionCall(
          "",
          ticketTypeDTO,
          orgClientInfoDetails.data && orgClientInfoDetails.data.clientCode
        );
      }
    );
  }

  handleIncompleteTickets(data) {
    this.setState({
      incompleteTicket: true,
      subject: data.subject,
      title: data.title,
      source: data.source,
      clientCode: data.clientCode,
      clientName: data.clientName,
      mobileNo: data.requestor.mobileNo,
      email: data.requestor.email,
      name: data.requestor.name,
      assigneeId: data.assigneeId,
      assigneeType: data.assigneeType,
      typeId: (data.ticketTypeDTO && data.ticketTypeDTO.id) || null,
      entityInput: data.entityId,
      parentId: null
    });
  }

  handleIncompleteAndChildTickets(data) {
    if (data) {
      if (data.status === "INCOMPLETE") {
        this.handleIncompleteTickets(data);
      } else {
        this.handleChildTickets(data);
      }
    }
  }

  isExternalTicket(ticketTypeDTO) {
    return (
      ticketTypeDTO.isLoaded &&
      ticketTypeDTO.data.ticketFieldType === ticketTypesDetailsStrings.EXTERNAL
    );
  }

  makeAutoSuggestionCall(input, ticketTypeDTO, clientCode) {
    if (this.state.typeId && ticketTypeDTO.data) {
      if (ticketTypeDTO.data.entityType !== "NONE" && !this.state.entityInput) {
        return;
      }
      if (!isNullOrEmptyString(input)) {
        if (this.assigneeSearchTimeout !== null) {
          clearTimeout(this.assigneeSearchTimeout);
        }
        this.assigneeSearchTimeout = setTimeout(
          this.props.getAssigneeOptions.bind(
            this,
            input,
            this.state.typeId,
            ticketTypeDTO.data.entityType,
            this.state.entityInput,
            clientCode
          ),
          500
        );
      } else {
        this.props.getGroupSuggestion(
          this.state.typeId,
          this.state.entityInput,
          this.state.clientCode
        );
      }
    }
  }

  updateCcList(ccEmailDetails) {
    if (ccEmailDetails.data) {
      const { ccList } = this.state;
      ccList.push({
        userEmail: ccEmailDetails.data.email,
        ticketId: this.state.incompleteTicket ? this.props.params.id : null
      });
      this.setState({
        ccList
      });
    } else {
      toastr.error("User not found!");
    }
  }

  updateFormData() {
    const { ticketTypeDTO, ticket } = this.props.createTicketState;
    const isExternalTicket = this.isExternalTicket(ticketTypeDTO);
    let entityId = this.state.entityInput;
    if (entityId && typeof entityId === "string") {
      entityId = entityId.trim();
    }
    const formData = {
      typeId: this.state.typeId,
      source: this.state.source,
      entityId:
        this.shouldRenderEntityInput(ticketTypeDTO) && entityId
          ? entityId
          : null,
      parentId: this.state.parentId,
      clientCode: isExternalTicket ? this.state.clientCode : null,
      clientName: isExternalTicket ? this.state.clientName : null,
      requestor: {
        mobileNo: isExternalTicket ? this.state.mobileNo : null,
        email: isExternalTicket ? this.state.email : null,
        name: isExternalTicket ? this.state.name : null
      },
      title: this.state.title,
      subject: this.state.subject,
      assigneeId: this.state.assigneeId,
      assigneeType: this.state.assigneeType,
      ownerId: this.state.assigneeId,
      ownerType: this.state.assigneeType,
      id: this.state.incompleteTicket ? this.props.params.id : null,
      ccTicketDTOS: this.state.ccList,
      notificationEnabled: this.state.notificationEnabled,
      severity: this.state.severity
    };
    // eslint-disable-next-line
    console.log("hit post api to create ticket", formData);
    if (ticket.allowAPIcall) {
      if (this.state.autoAssignSuggestionID === formData.assigneeId) {
        this.sendGaEventObject("auto_assign_suggestion_used");
      }
      this.props.createTicketSubmit(formData, formData.id);
    }
  }

  updateTicketData(ticket) {
    if (ticket.data) {
      this.setState(
        {
          ticketCreated: true,
          ticketCreatedId: ticket.data.id,
          showTicketCreatedModal: true
        },
        () => {
          this.sendGaEventObject("ticket_created");
          if (
            this.props.attachmentState.uploadFilesSelected &&
            this.props.attachmentState.uploadFilesSelected.length
          )
            this.createZipFileToSend(this.state.ticketCreatedId);
        }
      );
    }
  }

  updateUserInfo(userInfo) {
    if (
      userInfo.data &&
      userInfo.data !== this.props.createTicketState.userInfo.data
    ) {
      if (
        isNullOrEmptyString(this.state.mobileNo) ||
        isNullOrEmptyString(this.state.email) ||
        isNullOrEmptyString(this.state.name)
      ) {
        this.setState({
          mobileNo: isNullOrEmptyString(this.state.mobileNo)
            ? userInfo.data.mobileNo
            : this.state.mobileNo,
          email: isNullOrEmptyString(this.state.email)
            ? userInfo.data.email
            : this.state.email,
          name: isNullOrEmptyString(this.state.name)
            ? userInfo.data.name
            : this.state.name
        });
      }
    } else if (!userInfo.data) {
      toastr.info("This mobile/email is not registered");
    }
  }

  validateData() {
    const { ticketTypeDTO } = this.props.createTicketState;
    if (!this.state.buId) {
      return "Please select Business unit";
    }
    if (!this.state.typeId) {
      return "Please select ticket type";
    }
    if (this.shouldRenderEntityInput(ticketTypeDTO)) {
      if (!this.state.entityInput) {
        return `Please enter ${ticketTypeDTO.data.entityType}`;
      } else if (this.state.invalidCnOrPRQ) {
        return `Enter valid ${ticketTypeDTO.data.entityType}`;
      }
    }
    if (this.isExternalTicket(ticketTypeDTO)) {
      if (!this.state.source || this.state.source === "") {
        return "Please enter source";
      }
      if (this.state.source === "PHONE" && !this.state.mobileNo) {
        return "Please enter mobile number";
      }
    }
    if (this.isPrimeClientCodeRequired(ticketTypeDTO)) {
      if (!this.state.clientCode || this.state.clientCode === "") {
        return "Please select client";
      }
    }
    if (!this.state.title || this.state.title === "") {
      return "Please enter title";
    }
    if (!this.state.assigneeId || this.state.assigneeId === "") {
      return "Please assign the ticket";
    }
    return null;
  }

  closeTicketCreatedModal() {
    this.setState({
      showTicketCreatedModal: false
    });
    const ticketdashboardRouteObj = {
      route: `/ticketdashboard`,
      zoomuinewroute: true
    };
    navigateToRouteHelper(ticketdashboardRouteObj);
  }

  createTicket() {
    const errorMessage = this.validateData();
    if (!errorMessage) {
      this.updateFormData();
    } else {
      toastr.error(errorMessage);
    }
  }

  createZipFileToSend(ticketId) {
    const zipFile = new JSZip();
    this.props.attachmentState.uploadFilesSelected.map(fileIterator =>
      zipFile.file(fileIterator.name, fileIterator)
    );
    zipFile
      .generateAsync({ type: "blob" })
      .then(zipFileCreated => {
        const zipFileToSend = new File(
          [zipFileCreated],
          `${ticketId}_${this.props.userProfile.user_id}_${Date.now()}.zip`
        );
        this.setState(
          {
            zipFileToBeSent: zipFileToSend
          },
          () => {
            const formdata = new FormData();
            formdata.append("ticketId", ticketId);
            formdata.append("text", "");
            formdata.append("file", this.state.zipFileToBeSent);
            formdata.append("recipients", "");
            formdata.append("subject", "");
            formdata.append("body", "");
            this.props.sendCommentsDetails(formdata, null, null, null, null);
          }
        );
      })
      .catch(error => {
        //  eslint-disable-next-line
        console.log("Attachments zipfile create failed", error);
      });
  }

  addCCEmail(val) {
    this.props.getCcDetails(val);
  }

  deleteFromCCList(i) {
    const { ccList } = this.state;
    ccList.splice(i, 1);
    this.setState({
      ccList
    });
  }

  shouldRenderEntityInput(ticketTypeDTO) {
    return ticketTypeDTO.isLoaded && ticketTypeDTO.data.entityType !== "NONE";
  }

  closeCCModal() {
    this.setState({
      showCCModal: false
    });
  }

  renderSource() {
    const { ticketTypeDTO } = this.props.createTicketState;
    if (!this.state.incompleteTicket && this.isExternalTicket(ticketTypeDTO)) {
      return (
        <div className={`${styles.utilityBar} l-row a-center flex-55`}>
          <div className={`${styles.rightInput}`}>
            <h2>Source*</h2>
          </div>
          <div className={`${styles.smallInputBox}`}>
            <BasicSelect
              label="Select source"
              selectedOpt={
                this.fillForIncompleteTickets()
                  ? this.props.viewTicketState.ticketDetails.data.source
                  : this.getDefaultSource().key
              }
              optionsArrOfObj={sourceOptions}
              onSelect={val => {
                this.onFormChange(formKeys.SOURCE, val);
              }}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  renderAssigneeInput() {
    const { assigneeOptions } = this.props.createTicketState;
    return (
      <div className={`${styles.utilityBar} l-row a-center`}>
        <div className="flex-15 l-row">
          <h2>Assign to*</h2>
        </div>
        <div>
          <div className={`${styles.smallInputBox}`}>
            <BasicSelect
              label="Select assignee/group"
              optionsArrOfObj={this.getAssigneeSelectOptions(assigneeOptions)}
              onSelect={(val, event) => {
                this.onFormChange(formKeys.ASSIGNEE, val, event);
              }}
              enableSearch={true}
              showOptions={this.state.showAssigneeOptions}
              onChangeInput={val => {
                this.onChangeAssigneeInput(val);
              }}
              selectedOpt={this.getAssigneeSelectedOpt()}
            />
          </div>
          <div>
            <div
              className={`${styles.viewCcButton}`}
              onClick={() =>
                this.setState({
                  showCCModal: true
                })
              }
            >
              CC Email ID
            </div>
            <div className="l-row">
              <input
                type="checkbox"
                checked={this.state.notificationEnabled}
                onChange={() => {
                  this.setState({
                    notificationEnabled: !this.state.notificationEnabled
                  });
                }}
              />
              <div className={`${styles.notificationText}`}>
                Notifications enabled
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderAttachmentModal() {
    return (
      <Modal
        showModal={this.state.showAttachmentModal}
        title="Attach Files"
        closeModal={() =>
          this.setState({
            showAttachmentModal: false
          })
        }
      >
        <div className={styles.attachmentModalWrapper}>
          <Attachments />
        </div>
        <div className={`l-row flex-100 ${styles.attachmentConfirmBtnWrapper}`}>
          <div
            className={` ${styles.attachmentConfirmBtn} l-row a-center j-center`}
            onClick={() => this.setState({ showAttachmentModal: false })}
          >
            Done
          </div>
        </div>
      </Modal>
    );
  }

  renderClientCode() {
    const {
      clientCodeOptions,
      primeClientCodeOptions,
      ticketTypeDTO,
      orgClientInfoDetails
    } = this.props.createTicketState;
    if (this.isPrimeClientCodeRequired(ticketTypeDTO)) {
      return (
        <div className={`${styles.utilityBar} l-row a-center`}>
          <div className="flex-15 l-row">
            <h2>Client Code*</h2>
          </div>
          <div className={`${styles.smallInputBox}`}>
            <BasicSelect
              label="Select client"
              optionsArrOfObj={this.getPrimeClientCodeSelectOptions(
                primeClientCodeOptions
              )}
              onSelect={(val, event) => {
                this.onFormChange(formKeys.CLIENT, val, event);
              }}
              enableSearch={true}
              showOptions={this.state.showClientCodeOptions}
              onChangeInput={val => {
                this.onChangePrimeClientCodeInput(val);
              }}
              displayNone={true}
            />
          </div>
        </div>
      );
    } else if (this.isExternalTicket(ticketTypeDTO)) {
      return (
        <div className={`${styles.utilityBar} l-row a-center`}>
          <div className="flex-15 l-row">
            <h2>Client Code</h2>
          </div>
          <div className={`${styles.smallInputBox}`}>
            <BasicSelect
              label="Select client"
              optionsArrOfObj={this.getClientCodeSelectOptions(
                clientCodeOptions
              )}
              onSelect={(val, event) => {
                this.onFormChange(formKeys.CLIENT, val, event);
              }}
              selectedOpt={this.getClientCodeSelectedOpt(orgClientInfoDetails)}
              enableSearch={true}
              showOptions={this.state.showClientCodeOptions}
              onChangeInput={val => {
                this.onChangeClientCodeInput(val);
              }}
              displayNone={true}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  renderCreateTicketModal() {
    return (
      <Modal
        showModal={this.state.showTicketCreatedModal}
        title={
          this.state.incompleteTicket ? "Ticket Completed" : "Ticket Created"
        }
        closeModal={() => this.closeTicketCreatedModal()}
      >
        {this.renderTicketCreatedModal()}
      </Modal>
    );
  }

  renderCCModal() {
    return (
      <div className="l-row a-center">
        <TicketingCcModal
          showLoader={false}
          showModal={this.state.showCCModal}
          title="View cc email"
          closeModal={() => {
            this.closeCCModal();
          }}
          ccList={this.state.ccList}
          addToCCList={val => {
            this.addCCEmail(val);
          }}
          deleteFromCCList={i => {
            this.deleteFromCCList(i);
          }}
        />
      </div>
    );
  }

  renderEntityInputBox() {
    const { ticketTypeDTO, locationData } = this.props.createTicketState;

    if (this.shouldRenderEntityInput(ticketTypeDTO)) {
      // If entityType is LOCATION, render dropdown
      if (
        ticketTypeDTO.data.entityType &&
        ticketTypeDTO.data.entityType.toLowerCase() === "location"
      ) {
        if (!locationData.isLoaded) {
          return (
            <div className={`${styles.utilityBar} l-row a-center`}>
              <div className="flex-15 l-row">
                <h2>{ticketTypeDTO.data.entityType}*</h2>
              </div>
              <div className={`${styles.smallInputBox}`}>
                <Loader />
              </div>
            </div>
          );
        }

        return (
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className="flex-15 l-row">
              <h2>{ticketTypeDTO.data.entityType}*</h2>
            </div>
            <div className={`${styles.smallInputBox}`}>
              <BasicSelect
                label="Select Location"
                enableSearch={true}
                optionsArrOfObj={this.getLocationSelectOptions(locationData)}
                onSelect={(val, event) => {
                  this.onFormChange(formKeys.ENTITY, val, event);
                }}
                selectedOpt={this.state.entityInput}
              />
            </div>
          </div>
        );
      }

      // For other entity types, render input field
      return (
        <div className={`${styles.utilityBar} l-row a-center`}>
          <div className="flex-15 l-row">
            <h2>{ticketTypeDTO.data.entityType}*</h2>
          </div>
          <div className={`${styles.smallInputBox}`}>
            <InputField
              placeholder={ticketTypeDTO.data.entityTypeDisplayName}
              type="text"
              onBlur={val =>
                this.getOrganisationClientDetails(
                  ticketTypeDTO.data.entityType,
                  val
                )
              }
              disabled={false}
              onChange={val => this.onFormChange(formKeys.ENTITY, val)}
              onKeyPress={event => {
                if (ticketTypeDTO.data.entityType === "CN") {
                  enableOnlyNumberInput(
                    event,
                    this.state.entityInput,
                    maxCNOTELength
                  );
                } else if (ticketTypeDTO.data.entityType === "PRQ") {
                  enableOnlyNumberInput(event, this.state.entityInput);
                }
              }}
            />
          </div>
          <div>
            {this.props.createTicketState.orgClientInfoDetails.isLoading ? (
              <Loader />
            ) : (
              ""
            )}
          </div>
        </div>
      );
    }
    return null;
  }

  renderRequestorDetails() {
    const { userInfo, ticketTypeDTO } = this.props.createTicketState;

    if (this.isExternalTicket(ticketTypeDTO)) {
      return (
        <div>
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className="flex-15 l-row">
              <h2>
                <u>Requestor Details</u>
              </h2>
            </div>
          </div>
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className="flex-15">
              <h2>
                Mobile
                {this.state.source === "PHONE" ? "*" : ""}
              </h2>
            </div>
            <div className={`${styles.smallInputBox}`}>
              <InputField
                placeholder="Mobile"
                type="tel"
                disabled={false}
                value={this.state.mobileNo}
                onBlur={val => this.getUserInfo(val, false)}
                onChange={val => this.onFormChange(formKeys.MOBILE, val)}
                onKeyPress={event =>
                  enableOnlyNumberInput(
                    event,
                    this.state.mobileNo,
                    maxMobileNumberLength
                  )
                }
              />
            </div>
            <div className={`${styles.rightInput}`}>
              <h2>Email ID*</h2>
            </div>
            <div className={`${styles.smallInputBox}`}>
              <InputField
                placeholder="Email"
                type="email"
                disabled={false}
                value={this.state.email}
                onBlur={val => this.getUserInfo(val, true)}
                onChange={val => this.onFormChange(formKeys.EMAIL, val)}
              />
            </div>
            <div className="l-row">{userInfo.isLoading ? <Loader /> : ""}</div>
          </div>
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className="flex-15 l-row">
              <h2>Name</h2>
            </div>
            <div className={`${styles.smallInputBox}`}>
              <InputField
                placeholder="Name"
                type="text"
                disabled={false}
                value={this.state.name}
                onChange={val => this.onFormChange(formKeys.NAME, val)}
              />
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  renderForm() {
    const { buTypes } = this.props.createTicketState;
    const { ticketDetails } = this.props.viewTicketState;
    return (
      <div>
        <div className={`${styles.utilityBar} l-row a-center`}>
          <div className="flex-15">
            <h2>Business Unit*</h2>
          </div>
          <div className={`${styles.smallInputBox}`}>
            <BasicSelect
              label="Select Unit"
              optionsArrOfObj={this.getBuSelectOptions(buTypes)}
              onSelect={(val, event) => {
                this.onFormChange(formKeys.BU, val, event);
              }}
              selectedOpt={
                this.state.fillingFromAPIResponse && ticketDetails.isLoaded
                  ? ticketDetails.data.ticketTypeDTO &&
                    ticketDetails.data.ticketTypeDTO.businessUnitDTO &&
                    ticketDetails.data.ticketTypeDTO.businessUnitDTO.unitName
                  : this.props.userProfile.business_unit.unitName
              }
            />
          </div>
          {this.renderSource()}
        </div>
        {this.renderGroupTypeInput()}
        {this.renderTicketTypeInput()}
        {this.renderEntityInputBox()}
        {this.renderClientCode()}
        {this.renderSeverityInput()}
        {this.renderRequestorDetails()}
        <div className={`${styles.utilityBar} l-row a-center`}>
          <div className="flex-15 l-row">
            <h2>Subject*</h2>
          </div>
          <div className={`${styles.longInputBox}`}>
            <InputField
              placeholder="Title"
              type="text"
              disabled={false}
              value={this.state.title}
              onChange={val => this.onFormChange(formKeys.TITLE, val)}
            />
          </div>
        </div>
        <div className={`${styles.utilityBar} l-row`}>
          <div className="flex-15 l-row">
            <h2>Description </h2>
          </div>
          <div>
            <div className={`${styles.richTextDiv}`}>
              <RichTextInput
                onChange={val => this.onFormChange(formKeys.SUBJECT, val)}
                defaultValue={
                  this.state.fillingFromAPIResponse &&
                  this.props.viewTicketState.ticketDetails.data
                    ? this.props.viewTicketState.ticketDetails.data.subject
                    : null
                }
              />
            </div>
            <div
              className={`${styles.viewCcButton}`}
              onClick={() =>
                this.setState({
                  showAttachmentModal: true
                })
              }
            >
              Attach Files
            </div>
          </div>
        </div>
        {this.renderAssigneeInput()}
        {this.renderCCModal()}
        {this.renderAttachmentModal()}
        <div className={`${styles.btnWrapper} l-row a-center`}>
          <div className="flex-15 l-row" />
          <div className="flex-20">
            <div
              className={`${styles.btnTextWrapper} btn-wrapper l-row j-center a-center`}
              onClick={() => this.createTicket()}
            >
              {!this.state.incompleteTicket ? "CREATE" : "COMPLETE"}
            </div>
          </div>
          <div>
            {this.props.createTicketState.ticket.isLoading ? <Loader /> : null}
          </div>
        </div>
        {this.state.ticketCreated ? this.renderCreateTicketModal() : null}
      </div>
    );
  }

  renderGroupTypeInput() {
    const { groupTypes } = this.props.categorySettingsState;
    return (
      <div className={`${styles.utilityBar} l-row a-center`}>
        <div className="flex-15">
          <h2>Category</h2>
        </div>
        <div className={`${styles.smallInputBox}`}>
          <BasicSelect
            label="Select category"
            enableSearch={true}
            optionsArrOfObj={this.getGroupTypeSelectOptions(groupTypes)}
            onSelect={(val, event) => {
              this.onFormChange(formKeys.GROUP_TYPE, val, event);
            }}
          />
        </div>
      </div>
    );
  }

  renderTicketCreatedModal() {
    return (
      <div>
        <div className={`${styles.successDialogText} l-row`}>
          {this.state.incompleteTicket ? (
            <div className="l-row">
              <div>Your ticket ID:</div>
              <div
                className={`${styles.successDialogLink} cursor-p`}
                onClick={() => this.onTicketCreatedModalClick()}
              >
                {` ${this.state.ticketCreatedId} `}
              </div>
              <div>is completed</div>
            </div>
          ) : (
            <div className="l-row">
              <div>Your ticket is created ID:</div>
              <div
                className={`${styles.successDialogLink} cursor-p`}
                onClick={() => this.onTicketCreatedModalClick()}
              >
                {this.state.ticketCreatedId}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderTicketTypeInput() {
    const { ticketTypes, ticketTypeDTO } = this.props.createTicketState;
    return (
      <div className={`${styles.utilityBar} l-row a-center`}>
        <div className="flex-15">
          <h2>Issue Type*</h2>
        </div>
        <div className={`${styles.smallInputBox}`}>
          <BasicSelect
            label="Select type"
            enableSearch={true}
            showOptions={this.state.showTicketTypeOptions}
            optionsArrOfObj={this.getTypeSelectOptions(ticketTypes)}
            onSelect={(val, event) => {
              this.onFormChange(formKeys.TYPE, val, event);
            }}
            selectedOpt={
              this.state.fillingFromAPIResponse && ticketTypeDTO.isLoaded
                ? ticketTypeDTO.data.name
                : null
            }
          />
        </div>
      </div>
    );
  }

  renderSeverityInput() {
    return (
      <div className={`${styles.utilityBar} l-row a-center`}>
        <div className="flex-15">
          <h2>Severity*</h2>
        </div>
        <div className={`${styles.smallInputBox}`}>
          <BasicSelect
            label="Select severity"
            optionsArrOfObj={getSeverityOptions(
              this.props.createTicketState.ticketTypeDTO.data,
              severityOptions
            )}
            onSelect={(val, event) => {
              this.onFormChange(formKeys.SEVERITY, val, event);
            }}
            selectedOpt={this.getSeveritySelectedOpt()}
          />
        </div>
      </div>
    );
  }

  render() {
    const { buTypes } = this.props.createTicketState;
    return (
      <div className={styles.createTicketWrapper}>
        {buTypes.isLoading ? <Loader /> : ""}
        {this.renderForm()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  createTicketState: state.createTicketState,
  viewTicketState: state.viewTicketState,
  userProfile: state.userProfile,
  attachmentState: state.attachmentState,
  ticketingSuggestionModalState: state.ticketingSuggestionModalState,
  categorySettingsState: state.categorySettingsState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getAllTicketTypes: bindActionCreators(getAllTicketTypes, dispatch),
  getTicketTypeDTO: bindActionCreators(getTicketTypeDTO, dispatch),
  createTicketSubmit: bindActionCreators(createTicketSubmit, dispatch),
  getEntityInfoDetails: bindActionCreators(getEntityInfoDetails, dispatch),
  getAssigneeOptions: bindActionCreators(getAssigneeOptions, dispatch),
  getClientCodeOptions: bindActionCreators(getClientCodeOptions, dispatch),
  getPrimeClientCodeOptions: bindActionCreators(
    getPrimeClientCodeOptions,
    dispatch
  ),
  getFilteredPrimeClientCodeOptionsAction: bindActionCreators(
    getFilteredPrimeClientCodeOptionsAction,
    dispatch
  ),
  getUserInfo: bindActionCreators(getUserInfo, dispatch),
  getTicketDetails: bindActionCreators(getTicketDetails, dispatch),
  clearStateAction: bindActionCreators(clearStateAction, dispatch),
  getCcDetails: bindActionCreators(getCcDetails, dispatch),
  getBuTypes: bindActionCreators(getBuTypes, dispatch),
  sendCommentsDetails: bindActionCreators(sendCommentsDetails, dispatch),
  getGroupSuggestion: bindActionCreators(getGroupSuggestion, dispatch),
  getEntityTypes: bindActionCreators(getEntityTypes, dispatch),
  getGroupTypesByBu: bindActionCreators(getGroupTypesByBu, dispatch),
  flushAttachmentState: bindActionCreators(flushAttachmentState, dispatch),
  getLocationData: bindActionCreators(getLocationData, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Responsive(CreateTicket));



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/createTicket/createTicket.js